import { render } from "./CustomNotesItem.vue?vue&type=template&id=1af9fde2&scoped=true&lang=pug"
import script from "./CustomNotesItem.vue?vue&type=script&lang=js"
export * from "./CustomNotesItem.vue?vue&type=script&lang=js"

import "./CustomNotesItem.vue?vue&type=style&index=0&id=1af9fde2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af9fde2"]])

export default __exports__